import { FormikDropdown, FormikTextField } from 'formik-office-ui-fabric-react'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import { ParticipantInsertInput, PersonType } from 'model'
import { IDropdownOption } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export interface ProvingDetailsManuellParticipantFormValues {
  participants: ParticipantInsertInput[]
  personType: PersonType
}

export class ProvingDetailsManuellParticipantFormSchema {
  constructor() {
    return Yup.object().shape({
      participants: Yup.array().of(
        Yup.object().shape({
          unknownPerson: Yup.object().shape({
            firstName: Yup.string()
              .trim()
              .required('Nachname ist ein Pflichtfeld'),
            surName: Yup.string()
              .trim()
              .required('Nachname ist ein Pflichtfeld'),
            supplier: Yup.string().trim(),
            email: Yup.string().trim(),
          }),
        })
      ),
    })
  }
}

export const ProvingDetailsManuellParticipantForm: React.FC<{
  orderIds: string[]
}> = ({ orderIds }) => {
  const { t } = useTranslation()

  const options: IDropdownOption[] = [
    { key: 'user', text: t('dropdown.option.pag') },
    { key: 'external', text: t('dropdown.option.dvt') },
    // { key: 'supplier/other', text: t('dropdown.option.') },
  ]

  return (
    <FormStack>
      <FieldStackItem
        name="personType"
        render={(fieldProps) => (
          <FormikDropdown
            label={t('field.participantType.label')}
            {...fieldProps}
            options={options}
            required={true}
          />
        )}
      />

      <FieldStack horizontal={true}>
        <FieldStackItem
          label={t('Vorname')}
          name={`participants.unknownPerson.firstName`}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          label={t('Nachname')}
          name={`participants.unknownPerson.surName`}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          label={t('Firma')}
          name={`participants.unknownPerson.supplier`}
          required={true}
          component={FormikTextField}
        />
        <FieldStackItem
          label={t('E-Mail')}
          name={`participants.unknownPerson.email`}
          required={true}
          component={FormikTextField}
        />
      </FieldStack>
    </FormStack>
  )
}
